module.exports = __webpack_public_path__ + "01f43047/img/note-edit-icon.acae1669.svg";